/**
 * Operator setter contract types (WP-806 / EC-843 / D-24713).
 *
 * The six operator-match-only moves (`operatorSetSupplyCount`,
 * `operatorMoveToDeckTop`, `operatorRevealNow`, `operatorMoveCard`,
 * `operatorAddEconomy`, `operatorEscapeVillain`) take these argument shapes. They
 * run only in an operator match (`G.isDebugMatch === true`), on the operator's own
 * turn, in the `main` stage, with no choice open (D-24689 §7, D-24713 §1).
 *
 * The WP-807 client pane consumes this contract through the engine's `.` surface.
 * All types are JSON-serializable. No boardgame.io import.
 */
/** Canonical list of the operator supply piles, in display order. */
export const OPERATOR_SUPPLY_PILES = ['wounds', 'bystanders', 'officers', 'sidekicks'];
// why: OD-1 (WP-806) — one submit adds at most 20; raising it changes no rule.
/** The largest amount one `operatorAddEconomy` submit may add. */
export const OPERATOR_ECONOMY_MAX_AMOUNT = 20;
/** Canonical list of the six operator setter move names. */
export const OPERATOR_SETTER_MOVE_NAMES = ['operatorSetSupplyCount', 'operatorMoveToDeckTop', 'operatorRevealNow', 'operatorMoveCard', 'operatorAddEconomy', 'operatorEscapeVillain'];
//# sourceMappingURL=operatorSetters.types.js.map